import React, { useCallback } from 'react';
import { RgbColor } from 'react-colorful';
import { hexToRgb } from '~/shared';
import { StyledContainer } from './Container.styled';
import { StyledInput, StyledInputContainer } from './Input.styled';
import { StyledTextContainer } from './TextContainer.styled';

interface ICameraSettingsItemColorProps {
	defaultValue?: string;
	children?: React.ReactNode;
	onChange?: (newValue: RgbColor) => void;
}

const CameraSettingsItemColor: React.FC<ICameraSettingsItemColorProps> = ({
	defaultValue,
	children,
	onChange,
}) => {
	const onInputChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const newValue = e.currentTarget.value
				.replace(/[^0-9a-fA-F]/g, '')
				.substring(0, 6)
				.toUpperCase();
			e.currentTarget.value = newValue;

			onChange?.(hexToRgb(newValue.padEnd(6, '0')));
		},
		[onChange],
	);

	return (
		<StyledContainer>
			<StyledTextContainer>{children}</StyledTextContainer>
			<StyledInputContainer>
				<StyledInput
					defaultValue={defaultValue ?? 'FFFFFF'}
					onChange={onInputChange}
				/>
			</StyledInputContainer>
		</StyledContainer>
	);
};

export { CameraSettingsItemColor };
